var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 308.8 308.8",
    style: {
      enableBackground: "new 0 0 308.8 308.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A566E"
    },
    d: "M35.6,18.8h180c19.6,0,35.6,16,35.6,35.6v185.2c0,19.6-16,35.6-35.6,35.6h-180 C16,275.2,0,259.2,0,239.6V54C0,34.8,16,18.8,35.6,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B594"
    },
    d: "M116.4,186.4l-52.8-52.8L0,197.2v13.2v28.8c0,19.6,16,35.6,35.6,35.6h180c19.6,0,35.6-16,35.6-35.6 v-28.8v-39.6l-59.6-60L116.4,186.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCC03"
    },
    cx: 114.8,
    cy: 103.6,
    r: 22.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 251.2,
    cy: 232.4,
    r: 57.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B594"
    },
    d: "M242.8,205.6c0-4.8,3.6-8.4,8.4-8.4c4.4,0,8.4,3.6,8.4,8.4V260c0,4.8-3.6,8.4-8.4,8.4 s-8.4-3.6-8.4-8.4V205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B594"
    },
    d: "M245.2,211.2c-3.2-3.2-3.2-8.4,0-11.6s8.4-3.2,11.6,0l19.2,19.2c3.2,3.2,3.2,8.4,0,11.6 s-8.4,3.2-11.6,0L245.2,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B594"
    },
    d: "M245.2,199.6c3.2-3.2,8.4-3.2,11.6,0s3.2,8.4,0,11.6L238,230.4c-3.2,3.2-8.4,3.2-11.6,0 s-3.2-8.4,0-11.6L245.2,199.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileupload);
export default __webpack_public_path__ + "static/media/fileupload.32248ac3706bfb4e9cba916b548db2f4.svg";
export { ForwardRef as ReactComponent };